module.exports = __webpack_public_path__ + "static/media/tbn_3.9440771d.webp";